import React from 'react'
import { useEffect, useState } from 'react'

import {
  getDatabase,
  ref,
  push,
  onValue,
} from 'firebase/database'

import classNames from './utils'
import './styles/chat.css'


const Chat = ({ app }) => {

  const db = getDatabase(app)

  const [messages, setMessages] = useState([])
  const [username, setUsername] = useState()
  const [input, setInput] = useState('')

  useEffect(() => {
    const messagesRef = ref(db, 'messages')

    // Subscribe to realtime updates
    const unsubscribe = onValue(messagesRef, (snapshot) => {
      const data = snapshot.val()
      const msgs = data
        ? Object.entries(data).map(([id, val]) => ({ id, ...val }))
        : []
      setMessages(msgs)
    })

    // Cleanup automatically handled by Firebase SDK
    return () => unsubscribe()
  }, [db])

  const submit = event => {
    event.preventDefault()
    if ( !username ) {
      setUsername(input)
    } else {
      const messagesRef = ref(db, 'messages')
      push(messagesRef, {
        username,
        text: input,
        timestamp: Date.now()
      })
    }
    setInput('')
  }

  const renderMessages = () => {
    return (
      <ul className="messages">
        {messages.map(message => (
          <li key={message.id} className={
            classNames('message', {
              'author': message.username === username
            })
          }>
            <strong>{message.username}: </strong>
            {message.text}
          </li>
        ))}
      </ul>
    )
  }

  const renderMessageInput = () => {
    return (
      <form className="message-input"
        onSubmit={event => submit(event)}>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={username ? 'message' : 'username'}
        />
        <button type="submit">
          {username ? 'Send' : 'Save'}
        </button>
      </form>
    )
  }

  return (
    <React.Fragment>
      {renderMessages()}
      {renderMessageInput()}
    </React.Fragment>
  )
}


export default Chat
